<ds-meta-badge
  [leading]="travelTime | travelTime"
  [trailing]="stops + ' stop' + (stops === 1 ? '' : 's')"
  trailingId="stops"
/>
